import { Notification, NotificationContent, NotificationContentDetails } from '@hr-outsourcing/shared';

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const normalizeNotificationDetails = (value: unknown): NotificationContentDetails | undefined => {
  if (!value) return undefined;

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (trimmed.startsWith('{')) {
      try {
        return normalizeNotificationDetails(JSON.parse(trimmed));
      } catch {
        return undefined;
      }
    }

    if (trimmed.startsWith('MESSAGES.')) {
      return { translationKey: trimmed };
    }

    return trimmed.length ? { rawText: trimmed } : undefined;
  }

  if (isRecord(value)) {
    if (typeof value.translationKey === 'string' || typeof value.rawText === 'string') {
      return {
        translationKey: typeof value.translationKey === 'string' ? value.translationKey : undefined,
        translationParams: isRecord(value.translationParams)
          ? (value.translationParams as Record<string, unknown>)
          : undefined,
        rawText: typeof value.rawText === 'string' ? value.rawText : undefined,
      };
    }
  }

  return undefined;
};

export const normalizeNotificationContent = (content: NotificationContent): NotificationContent => {
  if (typeof content === 'string') {
    const trimmed = content.trim();

    if (trimmed.startsWith('{')) {
      try {
        return normalizeNotificationContent(JSON.parse(trimmed) as NotificationContent);
      } catch {
        return content;
      }
    }

    return content;
  }

  if (isRecord(content) && 'details' in content) {
    return {
      ...content,
      details: normalizeNotificationDetails(content.details),
    };
  }

  return content;
};

export const normalizeNotification = (notification: Notification): Notification => ({
  ...notification,
  content: normalizeNotificationContent(notification.content),
});
